import type { MarketDialogueQuestionDto } from "../../autogen/bff-api";

export const MAX_QUESTIONS = 50;
export const MAX_QUESTION_LENGTH = 2000;

export const isQuestionTooLong = (question: MarketDialogueQuestionDto) =>
  !question.subject && question.text.length > MAX_QUESTION_LENGTH;

export const firstTooLongQuestion = (questions: MarketDialogueQuestionDto[]): number | null => {
  const index = questions.findIndex(isQuestionTooLong);
  return index < 0 ? null : index + 1;
};
